import { Collapse } from '@material-ui/core'
import { ChevronRight } from '@material-ui/icons'
import { useEffect, useState } from 'react'
import { RootStateOrAny, useDispatch, useSelector } from 'react-redux'
import { updateProject } from '../../../actions/projectActions'
import { useQuoteCalculator } from '../../../hooks/useQuoteCalculator'
import CheckboxInput from '../../Form/CheckboxInput'
import { ToggleButton } from './PromoCode'

interface Props {
  interactive: boolean
}

const MyCareDiscount = ({ interactive }: Props) => {
  const dispatch = useDispatch()

  const [expanded, setExpanded] = useState(false)

  const { userInfo } = useSelector((state: RootStateOrAny) => state.userLogin)
  const { project } = useSelector(
    (state: RootStateOrAny) => state.projectDetails
  )
  const { loading } = useSelector(
    (state: RootStateOrAny) => state.projectUpdate
  )
  const { projectRequests } = useSelector(
    (state: RootStateOrAny) => state.projectRequestsDetails
  )

  const total = useQuoteCalculator(projectRequests)

  const [isMyCareMember, setIsMyCareMember] = useState(project.isMyCareMember)

  useEffect(() => {
    //update the project immediately if toggle is changed
    if (isMyCareMember !== project.isMyCareMember) {
      const projectClone = { ...project, isMyCareMember }

      dispatch(updateProject(projectClone))
    }
  }, [isMyCareMember, dispatch, project])

  const handleExpandClick = () => {
    setExpanded(!expanded)
  }

  return (
    <>
      {!interactive ? (
        project.isMyCareMember ? (
          <div className="flex space-between m-b-8 m-t-8 primary">
            <div className="fs14 bold">Mycare discount</div>
            <div className="fs14 bold">
              {isNaN(Number(total))
                ? '-10%'
                : !project.discountCodes.length
                ? `-$${Number(
                    (Number(total) * 0.1).toFixed(0)
                  ).toLocaleString()}`
                : `-$${Number(
                    (Number(total) * 0.9 * 0.1).toFixed(0)
                  ).toLocaleString()}`}
            </div>
          </div>
        ) : null
      ) : (
        <>
          <div className={`flex space-between align-center`}>
            <div className="flex align-center">
              <ToggleButton
                onClick={handleExpandClick}
                aria-expanded={expanded}
                aria-label="show more"
                className={`fs14 bold ${expanded ? 'twist' : ''}`}
                startIcon={<ChevronRight />}
                disableRipple
              >
                MyCare rewards
              </ToggleButton>
            </div>

            {isMyCareMember ? (
              <div className="fs14">
                {isNaN(Number(total))
                  ? '-10%'
                  : !project.discountCodes.length
                  ? `-$${Number(
                      (Number(total) * 0.1).toFixed(0)
                    ).toLocaleString()}`
                  : `-$${Number(
                      (Number(total) * 0.9 * 0.1).toFixed(0)
                    ).toLocaleString()}`}
              </div>
            ) : null}
          </div>

          <Collapse in={expanded} timeout="auto" unmountOnExit>
            <CheckboxInput
              name="mycare membership"
              disabled={loading}
              value={isMyCareMember}
              setValue={setIsMyCareMember}
              label={
                <div className="fs12 m-t-10 m-b-0">
                  {userInfo.isAdmin ? (
                    `Apply MyCare Rewards for ${project.userName}`
                  ) : (
                    <>
                      Apply my MyCare Rewards. Not a MyCare member?{' '}
                      <a
                        className="link"
                        href="https://www.hexagonmi.com/en-us/service-and-support/mycare"
                        target="_blank"
                        rel="noreferrer noopener"
                      >
                        Learn more
                      </a>
                    </>
                  )}
                </div>
              }
              extraClasses="m-l-20 m-t--12"
            />
          </Collapse>
        </>
      )}
    </>
  )
}

export default MyCareDiscount
